export const PRODUCT_NAME = "AI破局天宫云平台";
